import { useState, FC, useEffect } from "react";
import { Chain, TokenInfo } from "./AssetsInterfaces"; 
import "./chainTokenItem.less";
import Copy from "../../images/copy.png";
import Copied from "../../images/copied.png";
import Explorer from "../../images/token-explorer.png";

interface IProps {
    chain: Chain
    tokenInfo: TokenInfo
}

const ChainTokenItem: FC<IProps> = (props: IProps) => {
    const { chain, tokenInfo } = props
    const [addressCopied, setAddressCopied] = useState(false)

    useEffect(() => {
        if (addressCopied) {
            setTimeout(() => {
                setAddressCopied(false)
            }, 1000)
        }
    }, [addressCopied])

    const compressedAddress = (address: string) => {
        const no0xAddress = address.replace("0x", "");

        if (chain.id === 12340001) {
            const removeVaultSuffixAddress =  address.replace(".Vault", "");
            return removeVaultSuffixAddress.slice(0, 6) + "..." + removeVaultSuffixAddress.slice(removeVaultSuffixAddress.length - 6)
        }

        return (address.includes("0x") ? "0x" : "") + no0xAddress.slice(0, 6) + "..." + no0xAddress.slice(no0xAddress.length - 6)
    }

    const copyString = async () => {
        if (addressCopied) {
            return
        }

        let finalAddress = tokenInfo.token.address

        if (chain.id === 12340001) {
            finalAddress =  finalAddress.replace(".Vault", "");
        }

        await navigator.clipboard.writeText(finalAddress)
        setAddressCopied(true)
    }

    const openExplorer = () => {
        let url = ""
        const blockExplorerUrl = chain.explore_url.endsWith("/")
          ? chain.explore_url.slice(0, chain.explore_url.length - 1)
          : chain.explore_url;
        if (chain.id === 12340001) {
            url = blockExplorerUrl + "/contract/" + tokenInfo.token.address.replace(".Vault", "")
        } else {
            url = blockExplorerUrl+ "/address/" + tokenInfo.token.address
        }
        window.open(url)
    }

    const tokenSymbol = () => {
        if (chain.id === 2222 && tokenInfo.token.symbol !== "USX") {
            return "ce" + tokenInfo.token.symbol
        } else if (chain.id === 12340001 && tokenInfo.token.symbol === "cfUSDC") {
            return "USDC"
        }
        return tokenInfo.token.symbol
    }

    return (
        <div className="token-item">
            <div className="leftItem"> 
                <img src={tokenInfo.icon} alt="" className="token-icon" />
                <div className="break"/>
                <div className="name">{tokenSymbol()}</div>
            </div>
            <div className="rightItem">
                <div className="token-address">{compressedAddress(tokenInfo.token.address).toLowerCase()}</div>
                <img src={addressCopied ? Copied : Copy} alt="" className="address-copy" onClick={copyString}/>
                <img src={Explorer} alt="" className="token-explorer" onClick={openExplorer}/>
            </div>
        </div>
    )
}

export default ChainTokenItem;